import config from "@/config"
import http from "@/utils/request"


export default {
    getTree: {
        url: `${config.API_URL}/api/app/ware-house-service-provider/tree`,
        name: "获取仓库服务商Tree",
        get: async function () {
            return await http.get(this.url);
        }
    },
    getWareHouseLogisticsList: {
        url: `${config.API_URL}/api/app/ware-house-logistics`,
        name: "获取物流渠道列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    syncWareHouseLogistics: {
        url: `${config.API_URL}/api/app/ware-house/sync-logistics`,
        name: "同步仓库物流渠道",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    updateIsEnable: {
        url: `${config.API_URL}/api/app/ware-house-logistics/is-enable`,
        name: "修改物流渠道启动状态",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    updateWareHouseLogistics: {
        url: `${config.API_URL}/api/app/ware-house-logistics/update`,
        name: "编辑修改物流渠道内容",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    updateShippingMap: {
        url: `${config.API_URL}/api/app/ware-house-logistics/update-shipping-map`,
        name: "修改发货映射",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    getGetByLogisticsId: {
        url: `${config.API_URL}/api/app/ware-house-shipping-map/by-logistics-id`,
        name: "根据物流渠道ID获取映射信息",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
}
